import { useQuery } from '@tanstack/react-query';
import { getMaterialById } from '../../api/materials/get-material-by-id';
import { materialsKeys } from './query-keys';

const useMaterialById = (materialId: number | null) =>
    useQuery({
        queryKey: materialsKeys.byId(materialId ?? 0),
        queryFn: () => getMaterialById(materialId as number),
        enabled: Boolean(materialId),
        refetchOnWindowFocus: false,
        refetchOnReconnect: false
    });

export default useMaterialById;
